import * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonDetailDataFragmentDoc } from '../editor.generated';
import * as Apollo from '@apollo/client';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type CreatePersonMutationVariables = Types.Exact<{
  personInput: Types.PersonInput;
}>;

export type CreatePersonMutation = {
  __typename?: 'Mutation';
  adminCreatePerson: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type UpdatePersonMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  personInput: Types.PersonInput;
}>;

export type UpdatePersonMutation = {
  __typename?: 'Mutation';
  adminEditPerson: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export const CreatePersonDocument = gql`
  mutation createPerson($personInput: PersonInput!) {
    adminCreatePerson(personInput: $personInput) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type CreatePersonMutationFn = Apollo.MutationFunction<
  CreatePersonMutation,
  CreatePersonMutationVariables
>;
export type CreatePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreatePersonMutation,
    CreatePersonMutationVariables
  >,
  'mutation'
>;

export const CreatePersonComponent = (props: CreatePersonComponentProps) => (
  <ApolloReactComponents.Mutation<
    CreatePersonMutation,
    CreatePersonMutationVariables
  >
    mutation={CreatePersonDocument}
    {...props}
  />
);

/**
 * __useCreatePersonMutation__
 *
 * To run a mutation, you first call `useCreatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonMutation, { data, loading, error }] = useCreatePersonMutation({
 *   variables: {
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useCreatePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePersonMutation,
    CreatePersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePersonMutation,
    CreatePersonMutationVariables
  >(CreatePersonDocument, options);
}
export type CreatePersonMutationHookResult = ReturnType<
  typeof useCreatePersonMutation
>;
export type CreatePersonMutationResult =
  Apollo.MutationResult<CreatePersonMutation>;
export type CreatePersonMutationOptions = Apollo.BaseMutationOptions<
  CreatePersonMutation,
  CreatePersonMutationVariables
>;
export const UpdatePersonDocument = gql`
  mutation updatePerson($id: UUID!, $personInput: PersonInput!) {
    adminEditPerson(id: $id, personInput: $personInput) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type UpdatePersonMutationFn = Apollo.MutationFunction<
  UpdatePersonMutation,
  UpdatePersonMutationVariables
>;
export type UpdatePersonComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdatePersonMutation,
    UpdatePersonMutationVariables
  >,
  'mutation'
>;

export const UpdatePersonComponent = (props: UpdatePersonComponentProps) => (
  <ApolloReactComponents.Mutation<
    UpdatePersonMutation,
    UpdatePersonMutationVariables
  >
    mutation={UpdatePersonDocument}
    {...props}
  />
);

/**
 * __useUpdatePersonMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMutation, { data, loading, error }] = useUpdatePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useUpdatePersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePersonMutation,
    UpdatePersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePersonMutation,
    UpdatePersonMutationVariables
  >(UpdatePersonDocument, options);
}
export type UpdatePersonMutationHookResult = ReturnType<
  typeof useUpdatePersonMutation
>;
export type UpdatePersonMutationResult =
  Apollo.MutationResult<UpdatePersonMutation>;
export type UpdatePersonMutationOptions = Apollo.BaseMutationOptions<
  UpdatePersonMutation,
  UpdatePersonMutationVariables
>;
